import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ColorPicker} from "vue3-colorpicker";
import {onMounted, PropType, ref, watch} from "vue";
import {defaultSuggestedColors} from "@/lib/components/form/selection/color/DefaultSuggestedColors";


export default /*#__PURE__*/_defineComponent({
  name: 'AutoColorPicker',
  props: {
  suggestedColors: {
    type: Array as PropType<String[]>,
    default: defaultSuggestedColors
  },
  switchToNextSuggestedColor: Number,
  inputShape: {
    type: String, // circle or square
    default: "circle"
  }
},
  emits: ['onColorPicked'],
  setup(__props, { emit }) {

const props = __props






const suggestedColorIndex = ref(0),
    pureColor = ref(props.suggestedColors[suggestedColorIndex.value] as string),
    gradientColor = ref("linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 100%)");

const onPureColorChange = () =>
{
  const pickedColor = pureColor.value;

  emit("onColorPicked", pickedColor);
}

watch(() => props.switchToNextSuggestedColor, () =>
{
  if (props.switchToNextSuggestedColor) // avoids calling at mounted
  {
    // auto selects the next color to save time
    if (++suggestedColorIndex.value < props.suggestedColors?.length)
    {
      pureColor.value = props.suggestedColors[suggestedColorIndex.value] as string;
      onPureColorChange();
    }
  }
});

onMounted(() =>
{
  onPureColorChange();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ColorPicker), {
    pureColor: pureColor.value,
    "onUpdate:pureColor": _cache[0] || (_cache[0] = ($event: any) => ((pureColor).value = $event)),
    gradientColor: gradientColor.value,
    "onUpdate:gradientColor": _cache[1] || (_cache[1] = ($event: any) => ((gradientColor).value = $event)),
    onPureColorChange: onPureColorChange,
    shape: __props.inputShape
  }, null, 8, ["pureColor", "gradientColor", "shape"]))
}
}

})